// HOOKS
import { useLazyQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import useQuery from "../other/useQuery.other.hook";

// GRAPHQL
import { GET_CUSTOMERS } from "../../graphql/queries/customers/customers.queries";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 25,
  sort: "-business_name",
};

const useGetManyCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [customerInput, setCustomerInput] = useState({});
  const [getCustomerQuery, { loading, error, data }] = useLazyQuery(
    GET_CUSTOMERS,
    {
      fetchPolicy: "no-cache",
    }
  );
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getCustomers = async () => {
    try {
      const res = await getCustomerQuery({
        variables: { query, customer: customerInput },
      });
      if (res?.data?.customers?.customers)
        setCustomers(res.data.customers.customers);
      if (res?.data?.customers?.metaData)
        setMetaData(res.data.customers.metaData);
    } catch (error) {
      console.error(`Error getting customer: ${error?.message}`);
      alert(`Error getting customer: ${error?.message}`);
    }
  };

  // Get customers on query or customerInput change
  useEffect(() => {
    getCustomers();
  }, [query, customerInput]);

  return {
    customers,
    setCustomers,
    getCustomers,
    metaData,
    setMetaData,
    customerInput,
    setCustomerInput,
    setQuery,
    query,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyCustomers;
